export const productos = [
  { value: "argentina", label: "Carrera Argentina" },
  { value: "exterior", label: "Carrera Exterior" },
  { value: "posgrados", label: "Posgrados" },
];
